module.exports = __webpack_public_path__ + "img/746761_291C19_AB9385_3C2B27-256px.0d170a28.png";